'use strict';

(function () {
  angular.module('zp.mixes').service('mixesService', mixesService);

  function mixesService(zpAPI) {

    var service = this;

    service.getAll = getAll;
    service.findOne = findOne;

    /////////////////////////////////////

    function getAll() {
      return zpAPI.http({
        method: 'GET',
        url: '/mixes'
      });
    }

    function findOne(alias) {
      return zpAPI.http({
        method: 'GET',
        url: '/mixes'
      }).then(function (response) {
        return response.find(function (item) {
          return item.alias === alias;
        });
      });
    }
  }
})();